<template>
  <main></main>
</template>

<script>
export default {
  mounted () {
    this.fn_SHOW_PROGRESS()
    if (this.fn_IS_SECRETARY()) {
      this.$http.get(`/secretary/doctor`, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.doctor = res.data[0]
          const profilePicture = this.doctor.profile_picture
            ? `${process.env.ROOT_API}/s3/file/doctor/${this.doctor.id}/profile_picture`
            : this.doctor.user.gender === 'F'
              ? require('@/assets/img/f_default.png')
              : require('@/assets/img/m_default.png')
          let profile = {
            id: this.doctor.user.id,
            name: this.doctor.user.name,
            displayName: this.doctor.displayName,
            picture: profilePicture
          }
          this.$store.dispatch('setUserProfile', profile)
          this.$router.replace({name: 'SecretaryAgenda'})
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      ).finally(
        () => {
          this.fn_HIDE_PROGRESS()
          this.loaded = true
        }
      )
      return
    }
    this.$http.get(`/doctor/registration_status`, this.$store.getters.getAuthHeader).then(
      (res) => {
        if (res.data !== 'Finalizado') {
          this.$router.replace({name: 'Register'})
        } else {
          this.$router.replace({name: 'DoctorAgenda'})
        }
      }
    ).catch(
      (err) => {
        console.log(err)
        this.loaded = true
      }
    )
  }
}
</script>
